import React, { useState } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, updateDoc, collection, addDoc } from "firebase/firestore";
import "./styles/admin.css";

const firebaseConfig = {
  apiKey: "AIzaSyDO-ivCiTJcGRD4ZQVxEefflp8dXigy_Fo",
  authDomain: "hellocar-777.firebaseapp.com",
  projectId: "hellocar-777",
  storageBucket: "hellocar-777.appspot.com",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// ✅ HARD-CODED ADMIN PASSWORD
const ADMIN_PASSWORD = "himnishbhansalirohitbhansaliblajpat77nagar";

export default function AdminConfirm() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");

  // ✅ Booking States
  const [bookingId, setBookingId] = useState("");
  const [booking, setBooking] = useState(null);
  const [message, setMessage] = useState("");

  // ✅ Product Adding States
  const [productData, setProductData] = useState({
    name: "",
    price: 0,
    img: "",
    description: "",
    type: "",
    brand: "",
    warranty: "",
    compatibleCars: "",
    specs: "",
    packageIncludes: "",
  });
  const [productMessage, setProductMessage] = useState("");

  // ✅ LOGIN HANDLER
  const handleLogin = () => {
    if (passwordInput === ADMIN_PASSWORD) {
      setLoggedIn(true);
    } else {
      alert("Incorrect Password ❌");
    }
  };

  // ✅ FETCH BOOKING
  const fetchBooking = async () => {
    try {
      const docRef = doc(db, "helloCarAppointments", bookingId.trim());
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setBooking(docSnap.data());
        setMessage("✅ Booking found. Ready to confirm payment.");
      } else {
        setMessage("❌ No booking found for that ID.");
      }
    } catch (err) {
      console.error(err);
      setMessage("⚠️ Error fetching booking.");
    }
  };

  // ✅ CONFIRM PAYMENT
  const confirmPayment = async () => {
    if (!booking) return setMessage("⚠️ Fetch a valid booking first.");

    try {
      const docRef = doc(db, "helloCarAppointments", bookingId.trim());
      await updateDoc(docRef, {
        isPaid: true,
        paidAt: new Date().toISOString(),
      });

      setMessage("✅ Payment confirmed!");

    } catch (err) {
      console.error(err);
      setMessage("❌ Error updating Firestore.");
    }
  };

  // ✅ HANDLE NEW PRODUCT INPUT CHANGE
  const handleProductChange = (e) => {
    setProductData({
      ...productData,
      [e.target.name]: e.target.value,
    });
  };

  // ✅ ADD PRODUCT TO FIRESTORE
  const handleAddProduct = async () => {
    try {
      // Transform comma-separated fields → arrays
      const cleanData = {
        ...productData,
        price: Number(productData.price),
        compatibleCars: productData.compatibleCars,
        specs: productData.specs.split(";;;").map(a => a.trim()),
        packageIncludes: productData.packageIncludes.split(";;;").map(a => a.trim()),
      };

      await addDoc(collection(db, "helloCarProducts"), cleanData);

      setProductMessage("✅ Product Added Successfully!");
      setProductData({
        name: "",
        price: 0,
        img: "",
        description: "",
        type: "",
        brand: "",
        warranty: "",
        compatibleCars: "",
        specs: "",
        packageIncludes: "",
      });
    } catch (err) {
      console.error(err);
      setProductMessage("❌ Error adding product.");
    }
  };

  // --------------------------------------------------------------------
  // ✅ UI OUTPUT
  // --------------------------------------------------------------------

  if (!loggedIn) {
    return (
      <div className="admin-login-screen">
        <h1>Admin Login</h1>
        <input
          type="password"
          placeholder="Enter Admin Password"
          value={passwordInput}
          onChange={(e) => setPasswordInput(e.target.value)}
          className="admin-input"
        />
        <button onClick={handleLogin} className="admin-btn confirm-btn">
          Enter Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="admin-confirm-page">

      <h1 className="admin-title">🔐 HelloCar Admin Dashboard</h1>

      {/* ------------------------------ */}
      {/* ✅ PRODUCT ADDING PANEL        */}
      {/* ------------------------------ */}
      <div className="admin-section">
        <h2>Add New Product</h2>

        <div className="admin-product-form">

          {Object.keys(productData).map((key) => (
            <input
              key={key}
              name={key}
              value={productData[key]}
              placeholder={key.replace(/([A-Z])/g, " $1")}
              onChange={handleProductChange}
              className="admin-input"
            />
          ))}

          <button onClick={handleAddProduct} className="admin-btn add-btn">
            ➕ Add Product
          </button>

          {productMessage && (
            <p className={`admin-message ${productMessage.includes("❌") ? "error" : "success"}`}>
              {productMessage}
            </p>
          )}
        </div>
      </div>

      {/* ------------------------------ */}
      {/* ✅ PAYMENT CONFIRMATION PANEL  */}
      {/* ------------------------------ */}
      <div className="admin-section">
        <h2>Confirm Booking Payment</h2>

        <input
          type="text"
          placeholder="Enter Booking ID"
          value={bookingId}
          onChange={(e) => setBookingId(e.target.value)}
          className="admin-input"
        />

        <button onClick={fetchBooking} className="admin-btn fetch-btn">
          Fetch Booking
        </button>

        <button onClick={confirmPayment} className="admin-btn confirm-btn">
          Confirm Payment
        </button>

        {booking && (
          <div className="admin-booking-details">
            <h3>Booking Details:</h3>
            <p><b>Name:</b> {booking.name}</p>
            <p><b>Phone:</b> {booking.phone}</p>
            <p><b>Email:</b> {booking.email}</p>
            <p><b>Date:</b> {booking.date}</p>
            <p><b>Time:</b> {booking.time}</p>
          </div>
        )}

        {message && (
          <p className={`admin-message ${message.includes("❌") ? "error" : "success"}`}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
}
